import { useEffect, useState } from "react";
import {
    FaMapMarkerAlt,
    FaExpand,
    FaWhatsapp,
    FaCalendarAlt,
    FaClock,
    FaLock,
    FaBuilding,
    FaVenusMars,
    FaSuitcase,
    FaPhoneAlt,
} from "react-icons/fa";
import {
    MdAcUnit,
    MdBalcony,
    MdBathtub,
    MdClose,
    MdHotTub,
    MdKeyboardArrowLeft,
    MdKeyboardArrowRight,
    MdKitchen,
    MdLocalLaundryService,
    MdMicrowave,
    MdTableRestaurant,
    MdTv,
    MdWifi,
} from "react-icons/md";
import { TbAirConditioning, TbFridge } from "react-icons/tb";
import { GiCooler, GiKitchenScale, GiTable, GiWashingMachine } from "react-icons/gi";
import Images from "../../Images";
import tw from "tailwind-styled-components";
import axios from "axios";
import Config, { media_types } from "../../Config";
import { useParams } from "react-router-dom";
import { useMutation } from "react-query";
import { capitalizeFirstLetter } from "../../helpers";
import { FaKitchenSet } from "react-icons/fa6";


const PropertyShareLink = () => {
    const { gId } = useParams()
    const [showAllPhotos, setShowAllPhotos] = useState(false);
    const [selectedSharing, setSelectedSharing] = useState(0);
    const [fullScreenImageIndex, setFullScreenImageIndex] = useState(0);
    const [apiData, setApiData] = useState(null)
    const [allImages, setAllImages] = useState([]);
    const [allImageDetails, setAllImageDetails] = useState([]);
    const DUMMY_PROPERTY_IMAGE = Images.DummyProperty;
    const propertyType = [
        { value: 1, label: "PG/Hostel/Co-Living" },
        { value: 2, label: "Flat/Apartment" },
    ];
    const tenantPrefrence = [
        { value: 1, label: "Male" },
        { value: 2, label: "Female" },
        { value: 3, label: "Both" },
    ];
    const getImageTypeLabel = (typeValue) => {
        const found = media_types.find(item => item.value === typeValue);
        return found ? found.label : 'Unknown';
    };
    const getPropertyTypeLabel = (value) => {
        const found = propertyType.find(item => item.value === value);
        return found ? found.label : value;
    };

    const getTenantPreferenceLabel = (value) => {
        const found = tenantPrefrence.find(item => item.value === value);
        return found ? found.label : value;
    };
    const getRoomTypeLabel = (type) => {
        const roomTypes = {
            1: "Single Sharing",
            2: "Double Sharing",
            3: "Triple Sharing",
            4: "3+ Sharing",
        };
        return roomTypes[type] || "Shared Room";
    };
    const amenityIcons = {
        "Wi-Fi": MdWifi,
        "AC": MdAcUnit,
        "Attached Bathroom": MdBathtub,
        "TV": MdTv,
        "Balcony": MdBalcony,
        "Cooler": GiCooler,
        "Geyser": MdHotTub,
        "Washing Machine": MdLocalLaundryService,
        "Attached Kitchen": FaKitchenSet,
        "Fridge": MdKitchen,
        "Microwave": MdMicrowave,
        "Almirah": FaSuitcase,
        "Induction": GiKitchenScale,
        "Study Table": MdTableRestaurant
    };

    const fetchFunction = async () => {

        const response = await axios.get(
            `${Config.apiUrl}/property/share?propGId=${gId}`,
            {
                headers: {
                    // authorization: `Bearer ${user.token}`,
                },
            }
        );
        return response.data;
    };

    const getSuccess = (res) => {
        setApiData(res);
        const images = res?.propertyImages?.map(item => item.imageUrl) || [];
        setAllImages(images);
        const imageDetails = res?.propertyImages || [];
        setAllImageDetails(imageDetails);
    };

    const {
        isLoading,
        mutate: getListMutate,
    } = useMutation(fetchFunction, {
        onSuccess: getSuccess,
    });

    useEffect(() => {
        getListMutate();
    }, []);
    useEffect(() => {
        if (apiData?.property?.name) {
            const propertyName = capitalizeFirstLetter(apiData.property.name);
            // const location = apiData.property.streetAddress
            //     ? ` - ${capitalizeFirstLetter(apiData.property.streetAddress)}`
            //     : '';
            //document.title = `${propertyName}${location} | Kipinn`;
            document.title = `${propertyName} - Property Overview`;
            const metaDescription = document.querySelector(
                'meta[name="description"]'
            );

            if (metaDescription) {
                metaDescription.setAttribute(
                    "content",
                    `View details of ${propertyName} including rental terms, amenities, facilities, images, and location information.`
                );
            }
        } else if (!isLoading && apiData === null) {
            document.title = "Property Details | Kipinn";
        }
    }, [apiData, isLoading]);
    const handleFullScreenNavigation = (direction) => {
        if (direction === "prev") {
            setFullScreenImageIndex((prev) =>
                prev === 0 ? allImages.length - 1 : prev - 1,
            );
        } else {
            setFullScreenImageIndex((prev) =>
                prev === allImages.length - 1 ? 0 : prev + 1,
            );
        }
    };

    // Full Screen Modal Component
    const FullScreenModal = () => {
        const currentImageDetails = allImageDetails[fullScreenImageIndex];
        const currentImageType = currentImageDetails?.type;
        const currentTypeLabel = getImageTypeLabel(currentImageType);

        return (
            <ModalOverlay>
                <CloseButton onClick={() => setShowAllPhotos(false)}>
                    <MdClose size={20} />
                </CloseButton>

                <ModalContent onClick={(e) => e.stopPropagation()}>
                    <ImageContainer>
                        <FullScreenImage
                            src={
                                allImages?.length > 0
                                    ? allImages[fullScreenImageIndex]
                                    : DUMMY_PROPERTY_IMAGE
                            }
                            // src={allImages[fullScreenImageIndex]}
                            alt={`Property ${fullScreenImageIndex + 1}`}
                            onError={(e) => {
                                e.target.onerror = null;
                                e.target.src = DUMMY_PROPERTY_IMAGE;
                            }}
                        />

                        <NavButton
                            className="left-2 sm:left-4"
                            onClick={() => handleFullScreenNavigation("prev")}
                        >
                            <MdKeyboardArrowLeft size={24} />
                        </NavButton>

                        <NavButton
                            className="right-2 sm:right-4"
                            onClick={() => handleFullScreenNavigation("next")}
                        >
                            <MdKeyboardArrowRight size={24} />
                        </NavButton>

                        <ImageCounter>
                            {/* Image {fullScreenImageIndex + 1} of {allImages.length}  */}
                            {currentTypeLabel}
                        </ImageCounter>
                    </ImageContainer>

                    <ThumbnailStrip>
                        {allImages.map((img, idx) => (
                            <ThumbnailButton
                                key={idx}
                                onClick={() => setFullScreenImageIndex(idx)}
                                className={
                                    idx === fullScreenImageIndex
                                        ? "border-blue-500 ring-2 ring-blue-200"
                                        : "border-gray-600 hover:border-gray-400"
                                }
                            >

                                <img
                                    src={img}
                                    alt={`Thumbnail ${idx + 1}`}
                                    className="w-full h-full object-cover"
                                    onError={(e) => {
                                        e.target.onerror = null;
                                        e.target.src = DUMMY_PROPERTY_IMAGE;
                                    }}
                                />
                            </ThumbnailButton>

                        ))}
                    </ThumbnailStrip>
                </ModalContent>
            </ModalOverlay>
        )
    };
    const AirbnbMapSection = ({ data }) => {
        const { latitude, longitude, name, address } = data;

        if (!longitude && !latitude) return null;

        const mapUrl = `https://www.google.com/maps?q=${latitude},${longitude}&z=15&output=embed`;

        return (
            <section className="border-t mt-12 pt-5 sm:pt-7">
                {/* Title */}
                <SectionTitle>
                    Where you'll be
                </SectionTitle>

                {/* Map Container */}
                <div className="relative h-[320px] sm:h-[420px] rounded-2xl overflow-hidden shadow-xl group">

                    {/* MAP (iframe) */}
                    <iframe
                        src={mapUrl}
                        className="w-full h-full"
                        loading="lazy"
                        referrerPolicy="no-referrer-when-downgrade"
                        title="Map location display"
                    ></iframe>

                    {/* DARK OVERLAY */}
                    {/* <div className="absolute inset-0 bg-black/10 group-hover:bg-black/0 transition duration-500"></div> */}

                    {/* GLASS CARD */}
                    <div className="absolute bottom-4 left-4 right-4 sm:left-6 sm:right-auto sm:w-[320px] 
                    backdrop-blur-xl bg-white/80 border border-white/40 
                    rounded-xl shadow-lg p-4 transition-all duration-300 group-hover:scale-[1.02]">

                        <div className="flex items-start gap-3">
                            <div className="bg-primary-color/10 text-primary-color p-2 rounded-lg">
                                📍
                            </div>

                            <div>
                                <h4 className="font-semibold text-sm sm:text-base text-gray-800 line-clamp-1">
                                    {name}
                                </h4>

                                <p className="text-xs sm:text-sm text-gray-600 mt-1">
                                    {address}
                                </p>

                                {/* BUTTONS */}
                                <div className="flex gap-2 mt-3">
                                    <a
                                        href={`https://www.google.com/maps/search/?api=1&query=${latitude},${longitude}`}
                                        target="_blank"
                                        rel="noreferrer"
                                        className="text-xs px-3 py-1.5 bg-primary-color text-white rounded-lg font-medium hover:opacity-90 transition"
                                    >
                                        View on Maps
                                    </a>

                                    <a
                                        href={`https://www.google.com/maps/dir/?api=1&destination=${latitude},${longitude}`}
                                        target="_blank"
                                        rel="noreferrer"
                                        className="text-xs px-3 py-1.5 bg-gray-100 text-gray-700 rounded-lg font-medium hover:bg-gray-200 transition"
                                    >
                                        Get Directions
                                    </a>
                                </div>
                            </div>
                        </div>
                    </div>

                    {/* TOP BADGE */}
                    <div className="absolute top-4 left-4 bg-white/90 backdrop-blur-md px-3 py-1 rounded-lg text-xs font-semibold shadow">
                        📍 Prime Location
                    </div>
                </div>
            </section>
        );
    };
    if (isLoading) {
        return (
            <Container>
                <div className="flex items-center justify-center h-screen">
                    <div className="text-center">
                        <div className="animate-spin rounded-full h-12 w-12 border-b-2 border-primary-color mx-auto"></div>
                        <p className="mt-4 text-gray-600">Loading property details...</p>
                    </div>
                </div>
            </Container>
        );
    }

    return (
        <Container>

            <Header>
                <HeaderContainer>

                    {/* Left - Logo */}
                    {/* <Logo src={Images.Logo} alt="Kipinn Logo" /> */}
                    <div className="flex items-center gap-3">
                        <Logo src={Images.Logo} alt="Kipinn Logo" />
                        <div className="hidden md:flex items-center gap-3">
                            <div className="h-4 w-px bg-gray-300" />
                            <span className="text-sm font-medium text-gray-700">
                                PG & Coliving
                            </span>
                        </div>
                    </div>
                    {/* Right - Actions */}
                    <HeaderActions>

                        <WhatsAppHeaderBtn
                            onClick={() => {
                                const phone = apiData?.property?.ownerMobile;
                                if (!phone) return;

                                window.open(`https://wa.me/${phone}`, "_blank");
                            }}
                        >
                            <FaWhatsapp className="w-4 h-4" />
                            <span className="hidden sm:inline">WhatsApp</span>
                        </WhatsAppHeaderBtn>

                        <CallHeaderBtn
                            onClick={() => {
                                const phone = apiData?.property?.ownerMobile;
                                if (!phone) return;

                                window.location.href = `tel:${phone}`;
                            }}
                        >
                            <FaPhoneAlt  className="w-4 h-4" />
                            <span className="hidden sm:inline">Call</span>
                        </CallHeaderBtn>

                    </HeaderActions>

                </HeaderContainer>
            </Header>
            <Main>
                {/* Title Section */}
                <div className="mb-4 sm:mb-6 relative">
                    <Title>{capitalizeFirstLetter(apiData?.property?.name || '')}</Title>
                    <div className="flex flex-wrap items-center gap-2 mt-2 text-xs sm:text-sm text-gray-700">
                        <div className="flex items-center gap-1">
                            <FaMapMarkerAlt className="w-3 h-3 sm:w-4 sm:h-4" />
                            <LocationText>{capitalizeFirstLetter(apiData?.property?.streetAddress || '')}</LocationText>
                        </div>
                    </div>
                </div>

                {/* Photo Gallery */}
                <GalleryGrid>
                    <MainImageContainer>
                        {allImages?.length > 0 ? (
                            <GalleryImage
                                src={allImages[0]}
                                alt="Main"
                                onClick={() => {
                                    setFullScreenImageIndex(0);
                                    setShowAllPhotos(true);
                                }}
                                onError={(e) => {
                                    e.target.onerror = null;
                                    e.target.src = DUMMY_PROPERTY_IMAGE;
                                }}
                            />
                        ) : (
                            <div
                                className="
                                w-full h-full min-h-[220px] sm:min-h-[320px]
                                rounded-xl
                                bg-gray-100
                                flex flex-col items-center justify-center
                                px-4 text-center
                            "
                            >
                                <FaBuilding className="text-3xl sm:text-5xl text-gray-400 mb-3" />
                                <p className="text-sm sm:text-base text-gray-500 font-medium">
                                    No image available
                                </p>
                                <p className="text-xs sm:text-sm text-gray-400 mt-1">
                                    Photos will appear here once uploaded
                                </p>
                            </div>
                        )}
                    </MainImageContainer>

                    {allImages?.length > 1 ? (
                        allImages.slice(1, 5).map((img, idx) => (
                            <div key={idx} className="relative">
                                <GalleryImage
                                    src={img}
                                    alt={`Gallery ${idx + 2}`}
                                    onClick={() => {
                                        setFullScreenImageIndex(idx + 1);
                                        setShowAllPhotos(true);
                                    }}
                                    onError={(e) => {
                                        e.target.onerror = null;
                                        e.target.src = DUMMY_PROPERTY_IMAGE;
                                    }}
                                />

                                {idx === 3 && allImages.length > 5 && (
                                    <ShowAllPhotosButton
                                        onClick={() => {
                                            setFullScreenImageIndex(0);
                                            setShowAllPhotos(true);
                                        }}
                                    >
                                        <FaExpand className="w-3 h-3 sm:w-4 sm:h-4" />
                                        Show all photos
                                    </ShowAllPhotosButton>
                                )}
                            </div>
                        ))
                    ) : (
                        <>
                            {[1, 2, 3, 4].map((_, idx) => (
                                <div
                                    key={idx}
                                    className="
                                        hidden sm:flex
                                        bg-gradient-to-br from-gray-50 to-gray-100
                                        rounded-lg
                                        border border-gray-100
                                        min-h-[120px]
                                        items-center
                                        justify-center
                                        text-center
                                        px-3
                                    "
                                >
                                    <div className="flex flex-col items-center">
                                        <FaBuilding className="text-gray-300 text-lg mb-2" />
                                        <p className="text-xs font-medium text-gray-500">
                                            No image available
                                        </p>
                                        <p className="text-[10px] text-gray-400 mt-1 leading-tight">
                                            Photos will appear here once uploaded
                                        </p>
                                    </div>
                                </div>
                            ))}
                        </>
                    )}
                </GalleryGrid>

                <div className="grid grid-cols-1 lg:grid-cols-3 gap-6 sm:gap-8 lg:gap-12">
                    {/* Left Column - Details */}
                    <div className="lg:col-span-2">
                        {/* Host Info */}
                        <HostSection>
                            <HostInfo>
                                <div>
                                    <HostName>
                                        Entire rental unit managed by{" "}
                                        <span className="text-primary-color">
                                            {apiData?.property?.ownerName}
                                        </span>
                                    </HostName>
                                    <div className="flex items-center gap-1 mt-1">
                                        {/* <FaStar className="w-3 h-3 sm:w-4 sm:h-4 text-yellow-500 fill-current" /> */}
                                        <span className="text-xs sm:text-sm text-gray-600">
                                            Owner
                                        </span>
                                    </div>
                                </div>

                            </HostInfo>
                        </HostSection>

                        {/* Rental Terms Section */}

                        <Section className="border-b">
                            <SectionTitle>Rental Terms</SectionTitle>

                            <TermsGrid>
                                {[
                                    {
                                        icon: FaCalendarAlt,
                                        label: "Agreement Period",
                                        value: apiData?.property?.agreementPeriod ? `${apiData.property.agreementPeriod} month(s)` : "N/A",
                                    },
                                    {
                                        icon: FaClock,
                                        label: "Notice Period",
                                        value: apiData?.property?.noticePeriod ? `${apiData.property.noticePeriod} month(s)` : "N/A",
                                    },
                                    {
                                        icon: FaLock,
                                        label: "Lock-in Period",
                                        value: apiData?.property?.lockInPeriod ? `${apiData.property.lockInPeriod} month(s)` : "N/A",
                                    },
                                    {
                                        icon: FaBuilding,
                                        label: "Property Type",
                                        value: getPropertyTypeLabel(apiData?.property?.type),
                                    },
                                    {
                                        icon: FaVenusMars,
                                        label: "Tenant Preference",
                                        value: getTenantPreferenceLabel(apiData?.property?.tenantPreference),
                                    },
                                ].map((item, idx) => {
                                    const Icon = item.icon;
                                    return (
                                        <TermCard key={idx}>
                                            <IconWrapper>
                                                <Icon className="w-4 h-4 sm:w-5 sm:h-5" />
                                            </IconWrapper>

                                            <div>
                                                <p className="text-xs sm:text-sm text-gray-500">
                                                    {item.label}
                                                </p>
                                                <p className="text-sm sm:text-base font-semibold text-gray-800">
                                                    {item.value}
                                                </p>
                                            </div>
                                        </TermCard>
                                    );
                                })}
                            </TermsGrid>
                        </Section>
                        {/* Amenities */}
                        <Section>
                            <SectionTitle>What this place offers</SectionTitle>
                            <AmenitiesGrid>
                                {apiData?.roomOptions[selectedSharing]?.amenities?.split(',').map((amenity, idx) => {
                                    const AmenityIcon = amenityIcons[amenity.trim()];
                                    return (
                                        <div key={idx} className="flex items-center gap-2 sm:gap-3">
                                            {AmenityIcon && <AmenityIcon className="w-4 h-4 sm:w-5 sm:h-5 text-gray-700" />}
                                            <span className="text-sm sm:text-base text-gray-700">
                                                {amenity.trim()}
                                            </span>
                                        </div>
                                    );
                                })}
                            </AmenitiesGrid>
                        </Section>
                    </div>

                    {/* Right Column - Booking Card */}
                    <div className="lg:col-span-1">
                        <BookingCard>
                            <SectionTitle className="text-lg sm:text-xl">
                                Choose Sharing
                            </SectionTitle>
                            <div className="space-y-2 sm:space-y-3 mb-4 sm:mb-5">
                                {apiData?.roomOptions.map((item, index) => (
                                    <SharingOption
                                        key={index}
                                        onClick={() => setSelectedSharing(index)}
                                        className={
                                            selectedSharing === index
                                                ? "border-primary-color bg-primary-color/10 shadow-md"
                                                : "hover:shadow-sm"
                                        }
                                    >
                                        <div className="flex flex-col sm:flex-row sm:justify-between sm:items-center gap-2">
                                            <h4 className="text-sm sm:text-base font-semibold">
                                                {/* {item.type} */}
                                                {getRoomTypeLabel(item.type)}
                                            </h4>
                                            <span className="text-base sm:text-lg font-bold text-primary-color">
                                                ₹{item?.rent || 0}
                                                <span className="text-xs text-gray-500"> /month</span>
                                            </span>
                                        </div>

                                        <p className="text-xs text-gray-500 mt-1">
                                            Security: ₹{item?.security || 0}
                                        </p>

                                        <p className="text-xs text-green-600 mt-2">
                                            🏠 {item.availableRooms} rooms available
                                        </p>
                                    </SharingOption>
                                ))}
                            </div>

                            <CallButton
                                onClick={() => {
                                    const phone = apiData?.property?.ownerMobile;
                                    if (!phone) return;

                                    window.location.href = `tel:${phone}`;
                                }}
                                className="w-full py-2.5 sm:py-3 mb-3 sm:mb-4 flex items-center justify-center gap-2"
                            >
                                <FaPhoneAlt className="w-4 h-4 sm:w-5 sm:h-5" />
                                <span>Call Now</span>
                            </CallButton>
                            <div className="space-y-2 text-xs sm:text-sm">
                                <div className="flex justify-between">
                                    <span>Monthly Rent</span>
                                    <span>
                                        ₹
                                        {apiData?.roomOptions[
                                            selectedSharing
                                        ].rent || 0}
                                    </span>
                                </div>
                                <div className="flex justify-between">
                                    <span>Security Deposit</span>
                                    <span>
                                        ₹
                                        {apiData?.roomOptions[
                                            selectedSharing
                                        ].security || 0}
                                    </span>
                                </div>
                                <div className="border-t pt-2 sm:pt-3 mt-2 sm:mt-3 font-semibold flex justify-between">
                                    <span>Total Move-in Cost</span>
                                    <span>
                                        ₹
                                        {(
                                            apiData?.roomOptions[selectedSharing].rent +
                                            apiData?.roomOptions[selectedSharing].security
                                        ).toLocaleString()}
                                    </span>
                                </div>
                            </div>
                        </BookingCard>
                    </div>
                </div>
                {apiData?.property?.latitude && apiData?.property?.longitude &&
                    <AirbnbMapSection data={apiData?.property} />}
            </Main>
            <Footer>
                <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-10">
                    <div className="grid grid-cols-1 md:grid-cols-5 gap-8">

                        {/* Brand */}
                        <div className="md:col-span-3">
                            <img src={Images.Logo} alt="Kipinn" className="w-24 mb-3" />
                            <p className="text-sm text-gray-500 leading-relaxed">
                                Discover verified rental properties with transparent pricing and seamless experience on Kipinn.
                            </p>
                        </div>

                        {/* Property Info */}
                        <div className="md:col-span-2">
                            <h4 className="text-sm font-semibold text-gray-800 mb-3">
                                Property Info
                            </h4>
                            <div className="space-y-2 text-sm text-gray-600">
                                <p><strong>Name:</strong> {capitalizeFirstLetter(apiData?.property?.name || "")}</p>
                                <p><strong>Location:</strong> {capitalizeFirstLetter(apiData?.property?.streetAddress || "")}</p>
                                <p><strong>Type:</strong> {getPropertyTypeLabel(apiData?.property?.type)}</p>
                            </div>
                        </div>

                    </div>
                    <div className="border-t mt-8 pt-4 text-center text-xs text-gray-400">
                        © {new Date().getFullYear()} Kipinn. All rights reserved.
                    </div>
                </div>
            </Footer>

            {showAllPhotos && <FullScreenModal />}
        </Container>
    );
};


// ==================== STYLED COMPONENTS ====================

const Container = tw.div`min-h-screen bg-white`;
const Header = tw.header`border-b sticky top-0 bg-white z-40 shadow-sm`;
const HeaderContainer = tw.div`max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-4 flex items-center justify-between`;
const Logo = tw.img`w-16 sm:w-20`;
const HeaderActions = tw.div`
  flex items-center gap-2 sm:gap-3
`;
const Footer = tw.footer`
  bg-white 
  border-t border-gray-100 
  mt-10
`;
const WhatsAppHeaderBtn = tw.button`
  flex items-center gap-1 sm:gap-2
  bg-green-500 hover:bg-green-400
  text-white px-3 sm:px-4 py-2
  rounded-lg font-medium text-xs sm:text-sm
  transition-all duration-300 shadow-sm
`;

const CallHeaderBtn = tw.button`
  flex items-center gap-1 sm:gap-2
  bg-primary-color hover:bg-hover-color
  text-white px-3 sm:px-4 py-2
  rounded-lg font-medium text-xs sm:text-sm
  transition-all duration-300 shadow-sm
`;
const Main = tw.main`max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-4 sm:pt-6`;
const Title = tw.h1`text-xl sm:text-2xl md:text-3xl font-semibold leading-tight`;
const LocationText = tw.span`text-sm`;
// const GalleryGrid = tw.div`grid grid-cols-2 sm:grid-cols-4 gap-1 sm:h-80 md:h-96 rounded-xl overflow-hidden mb-6 sm:mb-8`;
// const MainImageContainer = tw.div`col-span-2 row-span-2 aspect-square lg:aspect-[3/2]`;
// const GalleryImage = tw.img`object-top w-full h-full object-cover cursor-pointer hover:opacity-95 transition-opacity`;
const ShowAllPhotosButton = tw.button`absolute bottom-3 lg:bottom-8 right-3 bg-white rounded-lg px-3 py-1.5 text-xs font-semibold flex items-center gap-2 shadow-md hover:bg-gray-100 transition-colors z-10`;
// Host Info Components
const HostSection = tw.div`flex flex-col sm:flex-row justify-between items-start border-b pb-4 sm:pb-6 `;
const HostInfo = tw.div`space-y-3 sm:space-y-4 w-full sm:w-auto`;
const HostName = tw.h2`text-xl sm:text-2xl font-semibold text-gray-900`;
const CallButton = tw.button`group relative px-4 sm:px-5 py-2 sm:py-2.5 bg-primary-color hover:bg-hover-color text-white rounded-xl font-semibold transition-all duration-300 flex items-center justify-center gap-2 text-sm sm:text-base`;
// Section Components
const Section = tw.section`py-5 sm:py-7`;
const SectionTitle = tw.h3`text-lg sm:text-xl font-semibold mb-4 relative inline-block after:content-[''] after:block after:h-[3px] after:w-12 after:bg-gradient-to-r after:from-primary-color after:to-blue-400 after:mt-1 after:rounded-full`;
const TermsGrid = tw.div`grid grid-cols-2 lg:grid-cols-3 gap-3 sm:gap-4`;
const TermCard = tw.div`flex items-center gap-3 p-3 sm:p-4 bg-white/70 backdrop-blur-md border border-gray-200 rounded-xl shadow-sm `;
const IconWrapper = tw.div`flex items-center justify-center w-9 h-9 sm:w-10 sm:h-10 rounded-full bg-primary-color/10 text-primary-color flex-shrink-0`;
const AmenitiesGrid = tw.div`grid grid-cols-1 sm:grid-cols-2 gap-3 sm:gap-4`;
// Booking Card Components
const BookingCard = tw.div`sticky top-24 border rounded-2xl shadow-xl p-4 sm:p-6 bg-white`;
const SharingOption = tw.div`cursor-pointer border rounded-xl p-3 sm:p-4 transition-allhover:shadow-md`;
// Full Screen Modal Components
const ModalOverlay = tw.div`fixed inset-0 bg-black/95 z-50 flex items-center justify-center`;
const CloseButton = tw.button`absolute top-4 right-4 z-50 text-white hover:text-gray-300 transition-colors bg-black/50 rounded-full p-2`;
const ModalContent = tw.div`w-full h-full flex flex-col items-center justify-center p-4`;
const ImageContainer = tw.div`relative flex items-center justify-center w-full h-[50vh] sm:h-[60vh] md:h-[70vh]`;
const FullScreenImage = tw.img`max-w-full max-h-full object-contain`;
const NavButton = tw.button`absolute top-1/2 -translate-y-1/2 bg-black/50 text-white rounded-full p-2 sm:p-3 hover:bg-black/70 transition-all z-10`;
const ImageCounter = tw.div`absolute bottom-4 left-1/2 -translate-x-1/2 bg-black/70 text-white px-3 sm:px-4 py-1.5 sm:py-2 rounded-lg text-xs sm:text-sm`;
const ThumbnailStrip = tw.div`flex gap-2 sm:gap-3 mt-4 sm:mt-6 overflow-x-auto pb-2 max-w-[90vw]`;
const ThumbnailButton = tw.button`flex-shrink-0 w-12 h-12 sm:w-16 sm:h-16 rounded-lg overflow-hidden border-2 transition-all`;
const GalleryGrid = tw.div`
  grid grid-cols-2 sm:grid-cols-4 grid-rows-2 gap-1
  sm:h-80 md:h-96
  rounded-xl overflow-hidden mb-4 sm:mb-8
`;

const MainImageContainer = tw.div`
  col-span-2 row-span-2
  h-[250px] sm:h-full
  w-full
  overflow-hidden
`;

const GalleryImage = tw.img`
  w-full h-full object-cover cursor-pointer hover:opacity-95 transition-opacity
`;

// const GalleryGrid = tw.div`
//   grid grid-cols-2 sm:grid-cols-4 gap-1
//   min-h-[220px] sm:h-80 md:h-96
//   rounded-xl overflow-hidden mb-4 sm:mb-8
// `;
// const MainImageContainer = tw.div`col-span-2 row-span-2`;
// const GalleryImage = tw.img`w-full h-full object-cover cursor-pointer hover:opacity-95 transition-opacity`;
export default PropertyShareLink;
